import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from "@neru/ui";
import { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import { useValidSession } from "../../hooks";
export var SecureRouteWithCookie = function() {
    var hasSession = useValidSession();
    var timeout = useRef();
    // Trigger user authorization on secure routes (launch workspace from Customer Dashboard)
    useEffect(function() {
        if (!hasSession) {
            timeout.current = setTimeout(function() {
                var path = encodeURIComponent("".concat(window.location.pathname).concat(window.location.search));
                window.location.href = "/sign-in?redirect=".concat(path, ";\n        }");
            }, 5 * 1000);
        } else {
            clearTimeout(timeout.current);
        }
        return function() {
            clearTimeout(timeout.current);
        };
    }, [
        hasSession
    ]);
    if (hasSession) {
        return /*#__PURE__*/ _jsx(Outlet, {});
    }
    return /*#__PURE__*/ _jsx(Spinner, {
        "data-testid": "pending-cookie-auth"
    });
};

//# sourceMappingURL=SecureRouteWithCookie.js.map